export const fbq = (...args) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq(...args);
  }
};

export const trackContact = (channel) => fbq("track", "Contact", { channel });
export const trackLead = (source) => fbq("track", "Lead", { source });
export const trackSchedule = () => fbq("track", "Schedule");
